import { memo } from 'react';
import { Controller, useWatch } from 'react-hook-form';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/core/Select';
import { AUTH_OBJECT_TYPES,useAuth } from '@/hooks/useAuth';
import { useDataModel } from '@/hooks/useDataModel';
import { useTranslation } from '@/hooks/useTranslation';

interface CategoryComponentProps {
    initialSelectedCategory?: string;
    isNewItem: boolean;
    disabled?: boolean;
}

const CoreCategoryComponent = ({ initialSelectedCategory, isNewItem, disabled }: CategoryComponentProps) => {

    const { t } = useTranslation();
    const { dataModel } = useDataModel();
    const { auth } = useAuth();

    const currentSelectedCategory = useWatch<{ category__: string }>({
        name: 'category__',
        defaultValue: initialSelectedCategory,
    });

    if (!dataModel || !auth) {
        return null;
    }

    const action = isNewItem ? 'create' : 'edit';
    const allDataModelCategories = dataModel.allCategories();
    const availableCategories = allDataModelCategories.filter((category) => {
        return (
            currentSelectedCategory === category.name ||
            auth.hasAnyPermission(AUTH_OBJECT_TYPES.OBJECT_TYPE_ITEMS, action, {
                category__: category.name,
            })
        );
    });

    return (
        <Controller
            name="category__"
            defaultValue={initialSelectedCategory}
            render={({ field }) =>
                <div id='select-categories'>
                    <Select value={field.value} onValueChange={field.onChange} disabled={!!disabled}>
                        <SelectTrigger className="tw-w-full">
                            <SelectValue id="category__" placeholder={t('CHOOSE_CATEGORY')} />
                        </SelectTrigger>
                        <SelectContent>
                            {availableCategories.map(category =>
                                <SelectItem key={category.name} value={category.name} data-value={category.name}>{t(`category.${category.name}`)}</SelectItem>
                            )}
                        </SelectContent>
                    </Select>
                </div>
            }
        />
    );
};

CoreCategoryComponent.DisplayName = 'CategoryComponent';

const CategoryComponent = memo(CoreCategoryComponent);

export { CategoryComponent };
